import React from 'react';
import ToolLayout from '../components/ToolLayout';
import { User } from 'lucide-react';

/**
 * Standalone Babysitter Quick Reference tool.
 * Generate a printable quick reference card for babysitters with essential emergency info.
 */
const BabysitterReferenceTool = () => {
  return (
    <ToolLayout
      title="Babysitter Quick Reference"
      description="Generate a printable quick reference card with essential emergency information for babysitters."
      icon={User}
      guide={{
        intro: 'Create a single-page reference card with everything a babysitter needs.',
        steps: [
          'Fill in your address and emergency numbers.',
          'Add parent and emergency contact info.',
          'Note allergies, medications, and procedures.',
          'Print the reference card and keep it visible.',
        ],
      }}
    >
      <div className="max-w-2xl mx-auto space-y-6">
        <p className="text-muted-foreground">
          Create a single-page reference with emergency numbers, address, parent contacts, medical info, and key procedures.
          Print and keep it in a visible location for babysitters.
        </p>
        <p className="text-sm text-muted-foreground">
          Full quick reference generator and print coming soon. You can pull key details from your Emergency Plan.
        </p>
      </div>
    </ToolLayout>
  );
};

export default BabysitterReferenceTool;
